import { useState, useEffect } from "react";
import React from "react";
import { machineProfile } from "../../api";
import { toast } from "react-toastify";
import { dateFormat, printLocation, renderImage } from "../../utils/helper";

import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";

function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}
function AddMachine() {
  const { machineId } = useParams();
  const editMode = !!machineId;
  const { locations } = useDashboardContext();
  const [sublocations, setSublocations] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [deletedDocument, setDeletedDocument] = useState([]);
  const [profilePicture, setProfilePicture] = useState(null);
  const [selectedFile, setSelectedFile] = useState("");
  const [docName, setDocName] = useState(null);
  const [machineClasses, setMachineClasses] = useState([]);
  const [areas, setAreas] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [sensors, setSensors] = useState([""]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [preview, setPreview] = useState();
  const [machineSpec, setMachineSpec] = useState("");
  const [productManual, setProductManual] = useState("");
  const [otherDoc, setOtherDoc] = useState("");
  const [machineElements, setMachineElements] = useState([]);
  const [deletedElements, setDeletedElements] = useState([]);
  const [deletedDeployments, setDeletedDeployments] = useState([]);
  const [deletedSchedules, setDeletedSchedules] = useState([]);
  const [deletedAttachments, setDeletedAttachments] = useState([]);
  const [locationValue, setLocationValue] = useState([]);
  const { getLocationName } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  const [dataToSend, setDataToSend] = useState({
    location_id: "",
    machine_brand: "",
    machine_model_no: "",
    machine_function: "Production",
    maintenance_frequency: "Monthly",
    production_output: "0",
    maintenance_manpower: "0",
    machine_power: "0",
    machine_speed: "0",
    machine_name: "",
    machine_type: "",
    start_operating_hour: "00:00",
    end_operating_hour: "00:00",
    machine_code: "",
    purchase_date: null,
    //warranty: "",
    warranty_date: null,
  });
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }
  const handleClose = () => setOpen(false);
  const handleClosePDF = () => setOpenPDF(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    bgcolor: "background.paper",
    border: "2px solid #000",
    divShadow: 24,
    p: "20px",
  };
  const handleFilesChange = (files) => {
    // Update chosen files
    setFilesToUpload([...files]);
  };

  async function getMasterData() {
    try {
      setIsLoading(true);
      const res_classes = await machineProfile.listMachineClass();
      //const res_area = await machineProfile.listMachineArea();
      if (res_classes.ok) {
        const body = await res_classes.json();

        setMachineClasses(body.data);
      }
      setSublocations([locations]);
      if (editMode) {
        await getRecord();
      } else {
        setIsLoading(false);
      }
    } catch (err) {}
  }

  useEffect(() => {
    if (locations.length) getMasterData();
  }, [locations]);

  async function getRecord() {
    const machine = await machineProfile.getOne(machineId);
    let activeMachine;
    if (machine.ok) {
      const body = await machine.json();
      let data = body.data;
      activeMachine = data;
    }

    if (activeMachine) {
      const defaultValue = {
        machine_id: machineId,
        location_id: activeMachine.location_id,
        machine_code: activeMachine.machine_code,
        machine_name: activeMachine.machine_name,
        machine_function: activeMachine.machine_function,
        machine_speed: activeMachine.machine_speed,
        production_output: activeMachine.production_output,
        machine_power: activeMachine.machine_power,
        machine_brand: activeMachine.machine_brand,
        machine_model_no: activeMachine.machine_model_no,
        machine_type: activeMachine.machine_type.name,
        warranty_date: activeMachine.warranty_date,
        purchase_date: activeMachine.purchase_date,
        attachments: activeMachine.attachments,
        start_operating_hour: activeMachine.start_operating_hour || "00:00",
        end_operating_hour: activeMachine.end_operating_hour || "00:00",
      };

      if (activeMachine.location) {
        //find parent
        const locationSeq = [];
        setupLocationValues(locationSeq, activeMachine.location);
        locationSeq.reverse();

        setLocationValue(locationSeq);
      }

      if (activeMachine.machine_elements) {
        const elements = activeMachine.machine_elements.map((e) => {
          return {
            ...e,
            sensors: e.deployments.map((d) => {
              return {
                ...d.sensor,
                ...d,
              };
            }),
          };
        });
        setMachineElements(elements);
        //defaultValue.machine_elements = JSON.stringify(elements);
      }

      if (activeMachine.scheduled_maintenances) {
        setSchedules(activeMachine.scheduled_maintenances);
      }
      if (activeMachine?.attachments?.filePhoto) {
        setPreview(
          renderImage(
            `machine/attachment/${activeMachine.attachments.filePhoto}`
          )
        );
      }
      if (activeMachine?.attachments?.machineSpec) {
        setMachineSpec({
          name: "Machine Spec",
          doc_path: renderImage(
            `machine/attachment/${activeMachine.attachments.machineSpec}`
          ),
        });
      }
      if (activeMachine?.attachments?.productManual) {
        setProductManual({
          name: "Product Manual",
          doc_path: renderImage(
            `machine/attachment/${activeMachine.attachments.productManual}`
          ),
        });
      }

      if (activeMachine?.attachments?.otherDoc) {
        setOtherDoc({
          name: "Other Doc",
          doc_path: renderImage(
            `machine/attachment/${activeMachine.attachments.otherDoc}`
          ),
        });
      }

      setDataToSend((prevData) => ({
        ...prevData,
        ...defaultValue,
      }));
      setIsLoading(false);
    }
  }

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  const handleMachineElementChange = (elements) => {
    setDataToSend((prevData) => ({
      ...prevData,
      deployments: JSON.stringify(elements),
    }));
  };

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);

  const handleLocationChange = (e, index) => {
    const location_values = [...locationValue];
    location_values.splice(index);
    location_values.push(e.target.value);
    setLocationValue(location_values);
  };
  const onAddChedule = (e) => {
    let copy = [...schedules];
    copy = [...copy, e];
    setSchedules(copy);
    //console.log({ schedules });
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      let hasil = { ...dataToSend };

      if (schedules) {
        for (var i = 0; i < schedules.length; i++) {
          schedules[i].start_date = dateFormat(schedules[i].start_date);
        }
      }
      hasil["schedules"] = JSON.stringify(schedules);
      hasil["location_id"] = locationValue[sublocations.length - 1];

      if (
        !hasil["location_id"] ||
        !hasil["machine_type"] ||
        !hasil["machine_code"] ||
        !hasil["machine_name"] ||
        !hasil["machine_brand"] ||
        !hasil["machine_function"] ||
        !hasil["machine_model_no"]
      ) {
        toast.error("Mandatory field must be filled");
        return;
      }

      //console.log({ hasil });
      setIsLoading(true);
      const res = await machineProfile.create2(
        hasil,
        selectedFile,
        machineSpec,
        productManual,
        otherDoc
      );
      setIsLoading(false);
      if (res.ok) {
        toast.success("Successfully Saved");
        backToList();
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  };

  const handleEdit = async () => {
    try {
      let hasil = { ...dataToSend };
      if (schedules) {
        for (var i = 0; i < schedules.length; i++) {
          schedules[i].start_date = dateFormat(schedules[i].start_date);
        }
      }
      hasil["schedules"] = JSON.stringify(schedules);
      //hasil["deleted_doc"] = deletedDocument;
      hasil["location_id"] = locationValue[sublocations.length - 1];
      hasil["deletedMachineElements"] = JSON.stringify(deletedElements);
      hasil["deletedDeployments"] = JSON.stringify(deletedDeployments);
      hasil["deletedSchedules"] = JSON.stringify(deletedSchedules);

      if (deletedAttachments.length > 0) {
        deletedAttachments.forEach((d) => {
          delete hasil["attachments"][d];
        });
      }
      hasil["attachments"] = JSON.stringify(hasil["attachments"]);

      if (
        !hasil["location_id"] ||
        !hasil["machine_type"] ||
        !hasil["machine_code"] ||
        !hasil["machine_name"] ||
        !hasil["machine_brand"] ||
        !hasil["machine_model_no"]
      ) {
        toast.error("Mandatory field must be filled");
        return;
      }
      setIsLoading(true);
      const res = await machineProfile.update2(
        machineId,
        hasil,
        selectedFile,
        machineSpec && machineSpec.size ? machineSpec : "",
        productManual && productManual.size ? productManual : "",
        otherDoc && otherDoc.size ? otherDoc : ""
      );
      setIsLoading(false);
      if (res.ok) {
        toast.success("Successfully Saved");
        backToList();
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  };

  const handleDateChange = (newValue) => {
    setDataToSend((prevData) => ({
      ...prevData,
      ["purchase_date"]: newValue,
    }));
  };
  const handleWarrantyDateChange = (newValue) => {
    setDataToSend((prevData) => ({
      ...prevData,
      ["warranty_date"]: newValue,
    }));
  };

  const onSelectTime = (key, moment) => {
    const time = moment.format("H:mm");

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: time,
    }));
  };
  const suspect_reason = [
    {
      uid: "Low Lubrican Oil",
      name: "Low Lubrican Oil",
    },
    {
      uid: "Engine Failure",
      name: "Engine Failure",
    },
  ];
  const action_required = [
    {
      uid: "Resolve",
      name: "Resolve",
    },
    {
      uid: "Pending",
      name: "Pending",
    },
  ];
  const listItem = [{ uid: "a1" }];
  const clickAdd = () => {
    let copy = [...sensors];
    copy = [...copy, ""];
    setSensors(copy);
  };

  const deleteSensor = (index) => {
    let copy = [...sensors];
    copy.splice(index, 1);
    setSensors(copy);
  };
  const deleteSchedule = (index) => {
    let copy = [...schedules];
    const deleted = copy.splice(index, 1);
    //console.log({ deleted });
    if (deleted.length > 0 && deleted[0].id) {
      setDeletedSchedules((prev) => [...prev, deleted[0].id]);
    }
    setSchedules(copy);
  };
  const deleteDocument = (doc, index) => {
    let copy = [...documents];
    copy.splice(index, 1);
    setDocuments(copy);
    let deletedDoc = deletedDocument;
    deletedDoc.push(doc.uid);
    setDeletedDocument(deletedDoc);
  };
  const changeSensor = (e, i) => {
    //console.log({ e, i });
    let copy = [...sensors];
    copy[i] = e.target.value;
    setSensors(copy);
  };
  const onMachineSpecFileClick = (e) => {
    document.getElementById("machinespecfile").click();
  };
  const handleMachineSpecChange = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setMachineSpec(undefined);
      return;
    }
    setMachineSpec(e.target.files[0]);
  };

  function onUpdateELement() {
    getRecord();
  }

  const onProductManualFileClick = (e) => {
    document.getElementById("productmanualfile").click();
  };
  const handleProductManualChange = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setProductManual(undefined);
      return;
    }
    //console.log("e.target.files[0]", e.target.files[0]);
    setProductManual(e.target.files[0]);
  };
  const onOtherDocFileClick = (e) => {
    document.getElementById("otherdocfile").click();
  };
  const handleOtherDocChange = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setOtherDoc(undefined);
      return;
    }
    setOtherDoc(e.target.files[0]);
  };
  const onSelectFile = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    //console.log({ selectedFile });
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    //console.log({ objectUrl });
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);
  return (
    <Card>
      <LoadingIndicator open={isLoading} text={deletedDeployments.length > 0 || deletedElements.length > 0 ? "Please wait, it will takes time to save your action." : ""} />
      <CardHeader>{editMode && "Edit "}Machine Information</CardHeader>

      <CardBody>
        <div className="row">
          <div className="col-9">
            <div>
              {sublocations.map((sublocation, index) => {
                return (
                  <NormalSelect
                    key={index}
                    required={true}
                    value={locationValue[index]}
                    label={getLocationName(index)}
                    onchange={(e) => handleLocationChange(e, index)}
                    list={sublocation}
                    name={`id`}
                    textKey="location_name"
                    renderFn={printLocation}
                  />
                );
              })}

              <NormalInput
                required={true}
                value={dataToSend["machine_code"]}
                label="Machine Code"
                onchange={handleOnchange}
                name="machine_code"
              />
              <NormalInput
                required={true}
                value={dataToSend["machine_name"]}
                label="Machine Name"
                onchange={handleOnchange}
                name="machine_name"
              />
              <NormalSelect
                required={true}
                value={dataToSend["machine_type"]}
                label="Machine Type"
                onchange={handleOnchange}
                list={machineClasses}
                name="machine_type"
              />
              <NormalInput
                required={true}
                value={dataToSend["machine_brand"]}
                label="Machine Brand"
                onchange={handleOnchange}
                name="machine_brand"
              />
              <NormalInput
                required={true}
                value={dataToSend["machine_model_no"]}
                label="Model Number"
                onchange={handleOnchange}
                name="machine_model_no"
              />
              <div className="row">
                <div className="col-6">
                  <NormalSelect
                    required={true}
                    value={dataToSend["machine_function"]}
                    label="Machine Function"
                    onchange={handleOnchange}
                    valueKey="name"
                    list={[
                      { name: "Production" },
                      { name: "Production Related" },
                      { name: "Utility" },
                    ]}
                    name="machine_function"
                  />
                </div>
                <div className="col-6">
                  {dataToSend["machine_function"] === "Production" ||
                  dataToSend["machine_function"] === "Production Related" ? (
                    <NormalInput
                      required={false}
                      value={dataToSend["production_output"]}
                      label="Production Output"
                      onchange={handleOnchange}
                      name="production_output"
                    />
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <NormalInput
                    required={false}
                    value={dataToSend["machine_power"]}
                    label="Machine Power (kW)"
                    onchange={handleOnchange}
                    name="machine_power"
                  />
                </div>
                <div className="col-6">
                  <NormalInput
                    required={false}
                    value={dataToSend["machine_speed"]}
                    label="Machine Speed (RPM)"
                    onchange={handleOnchange}
                    name="machine_speed"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <NormalSelect
                    required={true}
                    value={dataToSend["maintenance_frequency"]}
                    label="Maintenance Frequency"
                    onchange={handleOnchange}
                    valueKey="name"
                    list={[
                      { name: "Weekly" },
                      { name: "Monthly" },
                      { name: "Yearly" },
                    ]}
                    name="maintenance_frequency"
                  />
                </div>
                <div className="col-6">
                  <NormalInput
                    required={false}
                    value={dataToSend["maintenance_manpower"]}
                    label="Maintenance Manpower"
                    onchange={handleOnchange}
                    name="maintenance_manpower"
                  />
                </div>
              </div>
              <div mb={2}>
                <div>Date of Purchase</div>
                <div>
                  <DatepickerOpt
                    onValueChange={handleDateChange}
                    defaultValue={dataToSend["purchase_date"]}
                  />
                </div>
              </div>
              <div mb={2}>
                <div>Warranty End Date</div>
                <div xs={7} md={5} sm={7} lg={7}>
                  <DatepickerOpt
                    onValueChange={handleWarrantyDateChange}
                    defaultValue={dataToSend["warranty_date"]}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-3">
            <Card>
              <CardBody>
                <label htmlFor="files">
                  {preview ? (
                    <>
                      <img src={preview} className="img-thumbnail" alt="" />
                      <div
                        style={{
                          textAlign: "center",
                          cursor: "pointer",
                          marginTop: "5px",
                        }}
                      >
                        Change Photo <i className="fa fa-camera"></i>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          minHeight: "150px",
                          alignItems: "center",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <i className="fa fa-camera"></i>
                        <div>Add a Photo</div>
                      </div>
                    </>
                  )}
                </label>
                <input
                  id="files"
                  onChange={onSelectFile}
                  style={{ visibility: "hidden", position: "absolute" }}
                  type="file"
                  accept="image/png, image/jpeg"
                />
              </CardBody>
            </Card>
          </div>
        </div>
        <div mb={4}>
          <div md={9}>
            <div>
              <div mb={2}>
                <div className="mb-2">Operating Hours</div>
                <div>
                  <div className="row">
                    <div className="col-3">
                      From
                      <DateTime
                        onChange={(e) => {
                          onSelectTime("start_operating_hour", e);
                        }}
                        dateFormat={false}
                        timeFormat="H:mm"
                        value={dataToSend.start_operating_hour}
                      />
                    </div>

                    <div className="col-3">
                      To
                      <DateTime
                        onChange={(e) => {
                          onSelectTime("end_operating_hour", e);
                        }}
                        dateFormat={false}
                        timeFormat="H:mm"
                        value={dataToSend.end_operating_hour}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <p className="h6">Machine Element</p>

                <div className={"row"}>
                  <div className="col-sm-12 col-md-6">
                    <MachineElement
                      editMode={editMode}
                      defaultElements={machineElements}
                      onUpdateElement={onUpdateELement}
                      handleChange={handleMachineElementChange}
                      handleDeletedElements={(id) =>
                        setDeletedElements((prev) => [...prev, id])
                      }
                      handleDeletedDeployments={(id) => {
                        setDeletedDeployments((prev) => [...prev, ...id]);
                      }}
                    />
                  </div>
                </div>
              </div>

              <p className="h6 mt-4">Upload Related Documents</p>

              <div className="mb-2">
                <div className="mb-2">Machine Specification</div>
                <div className="small-input">
                  {machineSpec ? (
                    <div
                      style={{
                        display: "flex",
                        verticalAlign: "middle",
                        alignItems: "center",
                      }}
                    >
                      <a
                        style={{
                          fontSize: "12px",
                          lineHeight: "12px",
                          display: "block",
                          marginRight: "25px",
                        }}
                        target="_blank"
                        href={machineSpec.doc_path}
                      >
                        {machineSpec.name}
                      </a>
                      <span>
                        <button
                          className="btn btn-outline-danger"
                          onClick={() => {
                            setMachineSpec(undefined);
                            document.getElementById("machinespecfile").value =
                              "";
                            setDeletedAttachments((prev) => [
                              ...prev,
                              "machineSpec",
                            ]);
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </span>
                    </div>
                  ) : (
                    <button
                      onClick={() => onMachineSpecFileClick()}
                      style={{
                        border: "thin solid #5f6368",
                        display: "flex",
                        verticalAlign: "middle",
                        alignItems: "center",
                      }}
                      className="btn"
                    >
                      <i className="fa fa-file"></i>
                      <span style={{ padding: "0 10px" }}>Upload File</span>
                    </button>
                  )}
                  <input
                    id="machinespecfile"
                    required={true}
                    style={{ width: "100%", padding: "5px", display: "none" }}
                    type="file"
                    min={1}
                    placeholder={`Type the Floorplan`}
                    onChange={handleMachineSpecChange}
                    name={"machinespecfile"}
                    value={dataToSend["machineSpec"]}
                    accept="application/pdf"
                  />
                </div>
              </div>
              <div className="mb-2">
                <div className="mb-2">Product Manual</div>
                <div>
                  {productManual ? (
                    <div
                      style={{
                        display: "flex",
                        verticalAlign: "middle",
                        alignItems: "center",
                      }}
                    >
                      <a
                        style={{
                          fontSize: "12px",
                          lineHeight: "12px",
                          marginRight: "25px",
                          display: "block",
                        }}
                        target="_blank"
                        href={productManual.doc_path}
                      >
                        {productManual.name}
                      </a>
                      <span>
                        <button
                          className="btn btn-outline-danger"
                          onClick={() => {
                            setProductManual(undefined);
                            document.getElementById("productmanualfile").value =
                              "";
                            setDeletedAttachments((prev) => [
                              ...prev,
                              "productManual",
                            ]);
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </span>
                    </div>
                  ) : (
                    <button
                      className="btn"
                      onClick={() => onProductManualFileClick()}
                      style={{
                        border: "thin solid #5f6368",
                        display: "flex",
                        verticalAlign: "middle",
                        alignItems: "center",
                      }}
                    >
                      <i className="fa fa-file"></i>
                      <span style={{ padding: "0 10px" }}>Upload File</span>
                    </button>
                  )}
                  <input
                    id="productmanualfile"
                    required={true}
                    style={{ width: "100%", padding: "5px", display: "none" }}
                    type="file"
                    min={1}
                    placeholder={`Type the Floorplan`}
                    onChange={handleProductManualChange}
                    name={"productmanualfile"}
                    value={dataToSend["productManual"]}
                    accept="application/pdf"
                  />
                </div>
              </div>
              <div className="mb-2">
                <div className="mb-2">Other Documents</div>
                <div xs={7} md={4} sm={7} lg={4} className="small-input">
                  {otherDoc ? (
                    <div
                      style={{
                        display: "flex",
                        verticalAlign: "middle",
                        alignItems: "center",
                      }}
                    >
                      <a
                        style={{
                          fontSize: "12px",
                          lineHeight: "12px",
                          marginRight: "25px",
                          display: "block",
                        }}
                        target="_blank"
                        href={otherDoc.doc_path}
                      >
                        {otherDoc.name}
                      </a>
                      <span>
                        <button
                          className="btn btn-outline-danger"
                          onClick={() => {
                            setOtherDoc(undefined);
                            document.getElementById("otherdocfile").value = "";
                            setDeletedAttachments((prev) => [
                              ...prev,
                              "otherDoc",
                            ]);
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </span>
                    </div>
                  ) : (
                    <button
                      className="btn"
                      onClick={() => onOtherDocFileClick()}
                      style={{
                        border: "thin solid #5f6368",
                        display: "flex",
                        verticalAlign: "middle",
                        alignItems: "center",
                      }}
                    >
                      <i className="fa fa-file"></i>
                      <span style={{ padding: "0 10px" }}>Upload File</span>
                    </button>
                  )}
                  <input
                    id="otherdocfile"
                    required={true}
                    style={{ width: "100%", padding: "5px", display: "none" }}
                    type="file"
                    min={1}
                    placeholder={`Type the Floorplan`}
                    onChange={handleOtherDocChange}
                    name={"floorplan"}
                    value={dataToSend["otherDoc"]}
                    accept="application/pdf"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 flex">
          <button
            className="btn btn-outline-theme btn-lg me-2"
            onClick={editMode ? handleEdit : handleSubmit}
          >
            {editMode ? "SAVE" : "ADD"}
          </button>
          <button
            className="btn btn-outline-danger btn-lg"
            onClick={backToList}
          >
            CANCEL
          </button>
        </div>
      </CardBody>
    </Card>
  );
}

export default AddMachine;
